import { Instagram, Facebook, Music2, ArrowUpRight } from "lucide-react";
import { SOCIALS } from "../lib/contact";
import { useReveal } from "../hooks/useReveal";

const iconMap = {
  Instagram: Instagram,
  Facebook: Facebook,
  TikTok: Music2,
};

export const Socials = () => {
  const ref = useReveal();
  return (
    <section
      id="redes"
      data-testid="socials-section"
      className="relative py-24 md:py-36 bg-[#111] text-[#eeede9]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#ca0013]" />
            <span className="font-label text-xs text-[#ca0013]">
              Nuestras redes
            </span>
          </div>
          <h2
            data-testid="socials-title"
            className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.95] max-w-4xl"
          >
            Síguenos. Te mostramos
            <br />
            cómo lo{" "}
            <span className="font-editorial text-[#ca0013] font-normal">
              hacemos
            </span>
            .
          </h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/15 border border-white/15">
            {SOCIALS.map((s) => {
              const Icon = iconMap[s.name];
              return (
                <a
                  key={s.name}
                  data-testid={`social-card-${s.name.toLowerCase()}`}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-[#111] hover:bg-[#ca0013] p-10 md:p-12 transition-colors duration-500 flex flex-col justify-between min-h-[260px]"
                >
                  <div className="flex items-start justify-between">
                    <Icon size={36} strokeWidth={1.5} />
                    <ArrowUpRight
                      size={28}
                      className="opacity-50 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                    />
                  </div>
                  <div>
                    <div className="font-display text-3xl tracking-tight">
                      {s.name}
                    </div>
                    <div className="font-editorial text-xl text-[#eeede9]/70 group-hover:text-[#eeede9] mt-1">
                      {s.handle}
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
